import React from "react";
import "../home/home.css";
function Ccorporation() {
  return (
    <section className="section">
      <div className="section-center">
        <article className="activeSlide">
          <p className="title name-t">C Corporation</p>
          <h4 className="name-t">1120</h4>
          <p className="text text-p">
            Fingerstache umami squid, kinfolk subway tile selvage tumblr man
            braid viral kombucha gentrify fanny pack raclette pok pok
            mustache.Fingerstache umami squid, kinfolk subway tile selvage
            tumblr man braid viral kombucha gentrify fanny pack raclette pok pok
            mustache.Fingerstache umami squid, kinfolk subway tile selvage
            tumblr man braid viral kombucha gentrify fanny pack raclette pok pok
            mustache.Fingerstache umami squid, kinfolk subway tile selvage
            tumblr man braid viral kombucha gentrify fanny pack raclette pok pok
            mustache.
          </p>
        </article>
      </div>
    </section>
  );
}
export default Ccorporation;
